import WaitingDots from 'components/WaitingDots';
import { Account } from 'models/Account';
import { Person } from 'models/Person';
import React, { useState } from 'react';
import CustomerPersonChange from './CustomerPersonChange';
import { useAccountTranslation } from '../translations';

interface Props {
    person: Person;
    customer: Account;
    setPerson: (p: Person) => void;
}

const CustomerPersonRow: React.FC<Props> = ({ person, customer, setPerson }) => {

    const [change, setChange] = useState<boolean>(false)
    const { intlLocale, t } = useAccountTranslation();

    if (person === undefined) {
        return <WaitingDots />
    }

    if (change) {
        return <div className="portal-settings-form">
            <CustomerPersonChange customer={customer} person={person} setPerson={setPerson}
                onCancel={() => setChange(false)}
                save={() => setChange(false)} />
        </div>;
    }

    return <div className="portal-profile-summary">
        <span className="portal-profile-avatar" aria-hidden="true">
            {(person.name || "?").trim().slice(0, 1).toUpperCase()}
        </span>
        <div className="portal-profile-details">
            <strong>{person.name} {person.last_name}</strong>
            {person.title && <span>{person.title}</span>}
            <div>
                <span><i className="mdi mdi-email-outline" />{person.email || "—"}</span>
                <span><i className="mdi mdi-phone-outline" />{person.phone || "—"}</span>
                <span title={t("dateOfBirth")}><i className="mdi mdi-cake-variant-outline" aria-hidden="true" />{person.birth_date
                    ? new Intl.DateTimeFormat(intlLocale, { dateStyle: "long" }).format(new Date(`${person.birth_date}T00:00:00`))
                    : "—"}</span>
                <span><i className="mdi mdi-translate" />{person.locale?.toUpperCase() || "EN"}</span>
            </div>
        </div>
        <button type="button" className="portal-button portal-button-secondary" onClick={() => setChange(true)}>
            <i className="mdi mdi-pencil-outline" />{t("edit")}
        </button>
    </div>;
}

export default CustomerPersonRow;
